import {defineMessages, useIntl} from 'react-intl';
import {TextRow} from './TextRow';

const messages = defineMessages({
  assistantGreeting: {
    id: 'conversations_ui.support_conversations_client.universal_help_client.dot_com.assistantGreeting',
    description: 'Greeting message and disclaimer about the Assistant and AI.',
    defaultMessage: `Hi, I'm here to answer your questions. I'm powered by generative AI, so responses are for informational purposes only. You can find [more details here](https://support.stripe.com/questions/use-of-artificial-intelligence-(ai)-in-stripe-services). Please note that Stripe will handle your data as [described here](https://stripe.com/privacy).`,
  },
});

export function ChatStartedRowDotCom() {
  const intl = useIntl();

  const position = 'start';
  const messageType = 'bot';

  const body = intl.formatMessage(messages.assistantGreeting);

  return <TextRow body={body} messageType={messageType} position={position} />;
}
